
export default function VisionSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-blue-600 font-medium text-sm uppercase tracking-wide mb-2">VISION</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 leading-relaxed">
            <span className="md:hidden">私たちは、地域のビジネスを「マーケティングの力」で支えるチームです。</span>
            <span className="hidden md:block">
              <span className="block">私たちは、地域のビジネスを</span>
              <span className="block">「マーケティングの力」で支えるチームです。</span>
            </span>
          </h2>
          
          <div className="space-y-8 text-lg md:text-xl text-gray-700 leading-relaxed">
            <p className="text-left md:text-center">
              地方には、まだ伝わっていない魅力がたくさんあります。<br />
              その価値をもっと多くの人に届けるために、<br />
              私たちはマーケティングを"地域の成長エンジン"に変えていきます。
            </p>
            
            <p className="text-left md:text-center">
              SNSや広告、データ分析といった手法はあくまで手段。<br />
              本当に大切なのは、<strong className="text-blue-600 font-semibold">"地域の想いが伝わる仕組み"</strong>をつくることです。<br />
              一社一社の挑戦が、地方の未来を明るくしていく。<br />
              私たちは、その橋渡し役であり続けます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
